import { render, staticRenderFns } from "./SensorUpdateContainer.vue?vue&type=template&id=d28b5284&scoped=true&"
import script from "./SensorUpdateContainer.vue?vue&type=script&lang=ts&"
export * from "./SensorUpdateContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28b5284",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
